module.exports = __webpack_public_path__ + "img/pr-7.87071bdd.png";